import { Loader } from '@calendly/ui/components/loader';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import classNames from 'classnames';
import { forwardRef } from 'react';
const loadingSheetCss = "l1kunfze";
const LoadingSheet = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(loadingSheetCss, props.className)} />);
export const LoadingModal = () => <Modal isOpen>
    <LoadingSheet>
      <Loader />
    </LoadingSheet>
  </Modal>;

require("./loading_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./loading_modal.js");